import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const PercentageIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 15a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Zm0-2a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z", fill: "currentColor" }),
        React.createElement("path", { d: "m2.116 12.116 10-10a1.25 1.25 0 0 1 1.768 1.768l-10 10a1.25 1.25 0 0 1-1.768-1.768Z", fill: "currentColor" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 3.75a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z", fill: "currentColor" })));
});
PercentageIcon.displayName = 'PercentageIcon';
export default PercentageIcon;
